export default "__VITE_ASSET__B2ny_pAM__"